import React, { useEffect, useState } from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import deepEqual from 'deep-equal';
import config from '../../../../temp/config';
import { Helmet } from 'react-helmet';
import { pushToDataLayerEvent } from '../../../Foundation/Datalayer/CorpDatalayer';
import '@eshukumar123/common-feature-package/build/HeadlessNewHeader/styles/style.scss';

// This is boilerplate navigation for sample purposes. Most apps should throw this away and use their own navigation implementation.
// Most apps may also wish to use GraphQL for their navigation construction; this sample does not simply to support disconnected mode.
const CorporateLayout = ({ route }) => {
  const [opacity, setOpacity] = useState(0.05);
  const bodyClass = route?.fields?.BodyBackgroundCssClass?.value;
  if (typeof window !== 'undefined') {
    if (bodyClass && !document.body.classList.contains(bodyClass)) {
      document.body.classList.add(bodyClass);
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpacity(false);
    }, 150);

    return () => clearTimeout(timer);
  }, []);
  // Push dataLayer event on page load
  useEffect(() => {
    const pageType = route?.fields?.PageName?.value;
    if (pageType) {
      pushToDataLayerEvent({ pageType });
    }
  }, [route?.fields?.PageName?.value]);

  return (
    <React.Fragment>
      {/* <Skeleton /> */}
      <div className="true4oil-main-wrapper">
        <Helmet>
          <title>{route?.fields?.PageTitle?.value || 'TVS Motor TrueForOil'}</title>
          <link rel="preconnect" href="https://dynamic.criteo.com" crossOrigin="anonymous" />
          <link rel="preconnect" href="https://www.googleadservices.com" />
          <link rel="preconnect" href="https://adservice.google.com" />
          <link rel="preconnect" href="https://googleads.g.doubleclick.net" />
          <link rel="preconnect" href="https://www.googletagmanager.com" />
          <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
          <link rel="preconnect" href="https://fonts.googleapis.com" crossOrigin="anonymous" />
          <link rel="preconnect" href="https://cdn.evgnet.com" />
          <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
          <link rel="dns-prefetch" href="https://cdn.evgnet.com" />
          <link rel="dns-prefetch" href="https://www.googleadservices.com" />
          <link rel="dns-prefetch" href="https://adservice.google.com" />
          <link rel="dns-prefetch" href="https://googleads.g.doubleclick.net" />
          <link rel="dns-prefetch" href="https://www.googletagmanager.com" />
          <link rel="dns-prefetch" href="https://dev.visualwebsiteoptimizer.com" />
          <script async type="text/javascript" src={config.evergageScriptUrl}></script>
          <meta charset="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <link rel="canonical" href={route?.fields?.CanonicalUrl?.value} />
          <meta name="description" content={route?.fields?.MetaDescription?.value} />
          <meta name="keywords" content={route?.fields?.MetaKeywords?.value} />
          <meta name="viewport" content={route?.fields?.MetaViewport?.value} />
          <meta property="og:title" content={route?.fields?.OgTitle?.value} />
          <meta property="og:description" content={route?.fields?.OgDescription?.value} />
          <meta property="og:image" content={route?.fields?.OgImage?.value} />
          <meta property="og:url" content={route?.fields?.OgUrl?.value} />
          <meta property="og:type" content={route?.fields?.OgType?.value} />
          <meta property="og:site_name" content={route?.fields?.OgSitename?.value} />
          <meta name="twitter:title" content={route?.fields?.TwitterTitle?.value} />
          <meta name="twitter:description" content={route?.fields?.TwitterDescription?.value} />
          <meta name="twitter:image" content={route?.fields?.TwitterImage?.value} />
          <meta name="twitter:site" content={route?.fields?.TwitterSite?.value} />
          <meta name="twitter:creator" content={route?.fields?.TwitterCreator?.value} />
          <meta name="twitter:card" content={route?.fields?.TwitterCard?.value} />
          <meta name="twitter:url" content={route?.fields?.TwitterUrl?.value} />
          {/* Google Tag Manager */}
          <script>
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-KD53L7');`}
          </script>
          {/* End Google Tag Manager */}

          {route.fields.HeadSectionScripts[0]?.fields?.Details?.value && (
            <script type="application/ld+json">
              {route.fields.HeadSectionScripts[0].fields.Details.value}
            </script>
          )}
        </Helmet>

        {route?.fields?.HideHeader?.value ? null : (
          <Placeholder name="jss-header" rendering={route} />
        )}
        <Placeholder name="jss-main" rendering={route} />
        <div className="position-relative">
          <Placeholder name="jss-trufoil" rendering={route} />
        </div>
        {route?.fields?.HideFooter?.value ? null : (
          <Placeholder name="jss-footer" rendering={route} />
        )}
      </div>
    </React.Fragment>
  );
};

const propsAreEqual = (prevProps, nextProps) => {
  if (deepEqual(prevProps.route, nextProps.route)) return true;

  return false;
};

export default React.memo(CorporateLayout, propsAreEqual);
